module.exports = __webpack_public_path__ + "static/media/close.68d8ce88.svg";